// useFetchDobornye.js
import { useState, useEffect } from "react";

const useFetchDobornye = (path) => {
  const [dobornye, setDobornye] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDobornye = async () => {
      try {
        const response = await fetch(`${path}/api/dobornye`);
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const data = await response.json();
        setDobornye(data.dobornyeRows);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchDobornye();
  }, [path]);

  return { dobornye, loading, error };
};

export default useFetchDobornye;